import { render, staticRenderFns } from "./organizations-by-region-map-widget.vue?vue&type=template&id=6efa5b36&scoped=true&"
import script from "./organizations-by-region-map-widget.vue?vue&type=script&lang=js&"
export * from "./organizations-by-region-map-widget.vue?vue&type=script&lang=js&"
import style0 from "./organizations-by-region-map-widget.vue?vue&type=style&index=0&id=6efa5b36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efa5b36",
  null
  
)

export default component.exports